import Vue from 'vue'

/*
 * Dashboard
 */
Vue.component('tenant-dashboard-index', require('./views/tenant/Dashboard/index').default);
Vue.component('tenant-dashboard-sales-by-product', require('./views/tenant/Dashboard/items/SalesByProduct').default);

/*
 * User
 */

Vue.component('tenant-user-index', require('./views/tenant/Users/Index').default);

/*
 *
 */
Vue.component('tenant-synchronize-data-form', require('./views/tenant/configurations/SynchronizeData/Form').default);
Vue.component('tenant-payment_method_index', require('./views/tenant/configurations/PaymentMethod/Index').default);
Vue.component('tenant-payment_method_type_index', require('./views/tenant/configurations/PaymentMethodType/Index').default);
Vue.component('tenant-payment_condition_index', require('./views/tenant/configurations/PaymentCondition/Index').default);

/*
 * Account
 */
Vue.component('tenant-account-export', require('./views/tenant/Account/account/export').default);
Vue.component('tenant-account-concar-export', require('./views/tenant/Account/Concar/Export').default);
Vue.component('tenant-account-summary-report', require('./views/tenant/Account/summary_report/index').default);
Vue.component('tenant-account-format', require('./views/tenant/Account/account/format').default);
Vue.component('tenant-company-accounts', require('./views/tenant/Account/company_accounts/form').default);
Vue.component('tenant-ledger-accounts', require('./views/tenant/Account/ledger_accounts/form').default);

/*
 * Maintenance
 */
Vue.component('tenant-maintenance-operation-types', require('./views/tenant/Maintenance/OperationType/Index').default);
Vue.component('tenant-maintenance-note-credit-types', require('./views/tenant/Maintenance/NoteCreditType/Index').default);
Vue.component('tenant-maintenance-note-debit-types', require('./views/tenant/Maintenance/NoteDebitType/Index').default);

/*
 * Company
 */
Vue.component('tenant-pse-configuration', require('./views/tenant/companies/Pse/Configuration').default);
// Vue.component('tenant-signature-pse-index', require('./views/tenant/companies/signature_pse/index'))
Vue.component('tenant-whatsapp-api-index', require('./views/tenant/companies/whatsapp_api/index').default);
Vue.component('tenant-companies-form', require('./views/tenant/companies/form').default);
Vue.component('tenant-companies-logo', require('./views/tenant/companies/logo').default);

/*
 * Documents
 */
Vue.component('tenant-documents-index', require('./views/tenant/Documents/Index').default);
// Vue.component('tenant-documents-invoice', require('./views/tenant/Documents/invoice').default);
Vue.component('tenant-documents-invoicetensu', require('./views/tenant/Documents/invoicetensu').default);
Vue.component('tenant-documents-note-credit', require('./views/tenant/Documents/NoteCredit').default);
Vue.component('tenant-documents-note-debit', require('./views/tenant/Documents/NoteDebit').default);
Vue.component('tenant-documents-items-list', require('./views/tenant/Documents/partials/item').default);
Vue.component('tenant-documents-not-sent', require('./views/tenant/Document/documents/not_sent').default);
Vue.component('tenant-series-configurations-index', require('./views/tenant/Document/series_configurations/index').default);
Vue.component('tenant-validate-documents-index', require('./views/tenant/Document/validate_documents/index').default);
Vue.component('tenant-documents-regularize-shipping', require('./views/tenant/Document/documents/regularize_shipping').default);
Vue.component('tenant-documents-contingencies-index', require('./views/tenant/Document/contingencies/index').default);

Vue.component('tenant-documents-invoice-generate', require('./views/tenant/Documents/Form').default);
Vue.component('tenant-documents-invoice-generate-beta', require('./views/tenant/Documents/invoice_generate_beta').default);

// Trámite documentario
Vue.component('tenant-documentary-offices', require('./views/tenant/DocumentaryProcedure/offices/Offices').default);
Vue.component('tenant-documentary-status', require('./views/tenant/DocumentaryProcedure/status/Status').default);
Vue.component('tenant-documentary-processes', require('./views/tenant/DocumentaryProcedure/processes/Processes').default);
Vue.component('tenant-documentary-documents', require('./views/tenant/DocumentaryProcedure/documents/Documents').default);
Vue.component('tenant-documentary-actions', require('./views/tenant/DocumentaryProcedure/actions/Actions').default);
Vue.component('tenant-documentary-files', require('./views/tenant/DocumentaryProcedure/files/Files').default);
Vue.component('tenant-documentary-requirements', require('./views/tenant/DocumentaryProcedure/requirements/Requirements').default);
Vue.component('tenant-documentary-statistic', require('./views/tenant/DocumentaryProcedure/statistic/Index').default);
Vue.component('tenant-documentary-files-simplify', require('./views/tenant/DocumentaryProcedure/files_simplify/Files').default);
Vue.component('tenant-documentary-files-simplify-form', require('./views/tenant/DocumentaryProcedure/files_simplify/FilesNew').default);

Vue.component('tenant-finance-payment-method-types-index', require('./views/tenant/Finance/payment_method_types/index').default);
Vue.component('tenant-finance-unpaid-index', require('./views/tenant/Finance/unpaid/index').default);
Vue.component('tenant-finance-to-pay-index', require('./views/tenant/Finance/to_pay/index').default);
Vue.component('tenant-finance-income-index', require('./views/tenant/Finance/income/index').default);
Vue.component('tenant-finance-income-form', require('./views/tenant/Finance/income/form').default);
Vue.component('tenant-income-types-index', require('./views/tenant/Finance/income_types/index').default);
Vue.component('tenant-income-reasons-index', require('./views/tenant/Finance/income_reasons/index').default);
Vue.component('tenant-finance-movements-index', require('./views/tenant/Finance/movements/index').default);
Vue.component('tenant-finance-global-payments-index', require('./views/tenant/Finance/global_payments/index').default);
Vue.component('tenant-finance-balance-index', require('./views/tenant/Finance/balance/index').default);
Vue.component('tenant-finance-modal-transfer-between-accounts', require('./views/tenant/Finance/transfer_between_accounts/options').default);

Vue.component('tenant-ecommerce-configuration-info', require('./views/tenant/Ecommerce/configuration/index').default);
Vue.component('tenant-ecommerce-configuration-culqi', require('./views/tenant/Ecommerce/configuration_culqi/index').default);
Vue.component('tenant-ecommerce-configuration-paypal', require('./views/tenant/Ecommerce/configuration_paypal/index').default);
Vue.component('tenant-ecommerce-configuration-logo', require('./views/tenant/Ecommerce/configuration_logo/index').default);
Vue.component('tenant-ecommerce-configuration-social', require('./views/tenant/Ecommerce/configuration_social/index').default);
Vue.component('tenant-ecommerce-configuration-tag', require('./views/tenant/Ecommerce/configuration_tags/index').default);
Vue.component('tenant-ecommerce-item-sets-index', require('./views/tenant/Ecommerce/item_sets/index').default);
Vue.component('tenant-ecommerce-cart', require('./views/tenant/Ecommerce/cart_dropdown').default);
Vue.component('tenant-items-ecommerce-index', require('./views/tenant/items_ecommerce/index').default);

Vue.component('tenant-index-configuration', require('./views/tenant/BusinessTurn/configurations/index').default);

Vue.component('inventory-index', require('./views/tenant/Inventory/inventory/index').default);
Vue.component('inventory-transfers-index', require('./views/tenant/Inventory/transfers/index').default);
Vue.component('warehouses-index', require('./views/tenant/Inventory/warehouses/index').default);
Vue.component('tenant-report-kardex-index', require('./views/tenant/Inventory/kardex/index').default);
Vue.component('tenant-inventories-form', require('./views/tenant/Inventory/config/form').default);
Vue.component('inventory-review-index', require('./views/tenant/Inventory/inventory-review/index').default);

// Vue.component('tenant-inventory-report', require('./views/tenant/Inventory/inventory/reports/index').default);
Vue.component('tenant-inventory-report', require('./views/tenant/Inventory/Report/Index').default);
Vue.component('tenant-inventory-valued-kardex', require('./views/tenant/Inventory/Report/ValuedKardex').default);

Vue.component('tenant-inventory-color-index', require('./views/tenant/Inventory/extra_info/color/index').default);
Vue.component('tenant-inventory-item-units-per-package-index', require('./views/tenant/Inventory/extra_info/item_units_per_package/index').default);
Vue.component('tenant-inventory-item-units-business', require('./views/tenant/Inventory/extra_info/item_units_business/index').default);
Vue.component('tenant-inventory-item-package-measurements', require('./views/tenant/Inventory/extra_info/item_package_measurements/index').default);
Vue.component('tenant-inventory-mold-cavities', require('./views/tenant/Inventory/extra_info/item_mold_cavities/index').default);
Vue.component('tenant-inventory-mold-property', require('./views/tenant/Inventory/extra_info/item_mold_property/index').default);
Vue.component('tenant-inventory-size-property', require('./views/tenant/Inventory/extra_info/item_size/index').default);
Vue.component('tenant-inventory-item-status', require('./views/tenant/Inventory/extra_info/item_status/index').default);
Vue.component('tenant-inventory-item-product-family', require('./views/tenant/Inventory/extra_info/item_product_family/index').default);
Vue.component('tenant-inventory-extra-info-list', require('./views/tenant/Inventory/extra_info/index').default);
Vue.component('tenant-inventory-devolutions-index', require('./views/tenant/Inventory/devolutions/index').default);
Vue.component('tenant-inventory-devolutions-form', require('./views/tenant/Inventory/devolutions/form').default);
Vue.component('tenant-inventory_guides_index', require('./views/tenant/Inventory/Guide/Index').default);
Vue.component('tenant-inventory-report-stock', require('./views/tenant/Inventory/Report/Stock/Export').default);
Vue.component('moves-index', require('./views/tenant/Inventory/moves/index').default);
Vue.component('inventory-form-masive', require('./views/tenant/Inventory/transfers/form_masive').default);
Vue.component('tenant-report-kardex-master', require('./views/tenant/Inventory/kardex_master/index').default);
Vue.component('tenant-report-kardex-lots', require('./views/tenant/Inventory/kardex/lots').default);
Vue.component('tenant-report-kardex-series', require('./views/tenant/Inventory/kardex/series').default);
Vue.component('tenant-report-valued-kardex', require('./views/tenant/Inventory/valued_kardex/index').default);

/*
 * Purchase
 */
Vue.component('tenant-purchases-index', require('./views/tenant/purchases/Index').default);
Vue.component('tenant-purchases-form', require('./views/tenant/purchases/form').default);
Vue.component('tenant-purchases-edit', require('./views/tenant/purchases/form_edit').default);
Vue.component('tenant-fixed-asset-items-index', require('./views/tenant/purchases/fixed_asset_items/index').default);
Vue.component('tenant-fixed-asset-purchases-index', require('./views/tenant/purchases/fixed_asset_purchases/index').default);
Vue.component('tenant-fixed-asset-purchases-form', require('./views/tenant/purchases/fixed_asset_purchases/form').default);
Vue.component('tenant-purchase-quotations-index', require('./views/tenant/purchases/purchase-quotations/index').default);
Vue.component('tenant-purchase-quotations-form', require('./views/tenant/purchases/purchase-quotations/form').default);
Vue.component('tenant-purchase-orders-index', require('./views/tenant/purchases/purchase-orders/index').default);
Vue.component('tenant-purchase-orders-form', require('./views/tenant/purchases/purchase-orders/form').default);
Vue.component('tenant-purchase-orders-generate', require('./views/tenant/purchases/purchase-orders/generate').default);
Vue.component('tenant-purchase-settlements-index', require('./views/tenant/purchase-settlements/index').default);
Vue.component('tenant-purchase-settlements-form', require('./views/tenant/purchase-settlements/form').default);
Vue.component('tenant-purchases-note', require('./views/tenant/purchases/Note').default);

/*
 * Production
 */
Vue.component('tenant-mill-index', require('./views/tenant/Production/mill/index').default);
Vue.component('tenant-mill-form', require('./views/tenant/Production/mill/form').default);
Vue.component('tenant-machine-index', require('./views/tenant/Production/machine/index').default);
Vue.component('tenant-machine-type-index', require('./views/tenant/Production/machine/index_type').default);
Vue.component('tenant-machine-form', require('./views/tenant/Production/machine/form').default);
Vue.component('tenant-machine-type-form', require('./views/tenant/Production/machine/form_type').default);
Vue.component('tenant-workers-index', require('./views/tenant/Production/workers/index').default);
Vue.component('tenant-production-index', require('./views/tenant/Production/production/index').default);
Vue.component('tenant-production-form', require('./views/tenant/Production/production/form').default);
Vue.component('tenant-packaging-index', require('./views/tenant/Production/packaging/index').default);
Vue.component('tenant-packaging-form', require('./views/tenant/Production/packaging/form').default);

//Expense
Vue.component('tenant-expenses-index', require('./views/tenant/Expense/expenses/index').default);
Vue.component('tenant-expenses-form', require('./views/tenant/Expense/expenses/form').default);
Vue.component('tenant-expense-types-index', require('./views/tenant/Expense/expense_types/index').default);
Vue.component('tenant-expense-reasons-index', require('./views/tenant/Expense/expense_reasons/index').default);
Vue.component('tenant-expense-method-types-index', require('./views/tenant/Expense/expense_method_types/index').default);
Vue.component('tenant-bankloans-index', require('./views/tenant/Expense/bank_loans/index').default);
Vue.component('tenant-bankloans-form', require('./views/tenant/Expense/bank_loans/form').default);

/*
 * Retention
 */

Vue.component('tenant-retentions-index', require('./views/tenant/Retentions/Index').default);
Vue.component('tenant-retentions-form', require('./views/tenant/Retentions/Form').default);

/*
 * Restaurant
 */
Vue.component('tenant-restaurant-list-items', require('./views/tenant/Restaurant/items/index').default);
Vue.component('tenant-restaurant-promotions-index', require('./views/tenant/Restaurant/promotions/index').default);
Vue.component('tenant-restaurant-orders-index', require('./views/tenant/Restaurant/orders/index').default);
Vue.component('tenant-restaurant-cash-index', require('./views/tenant/Restaurant/cash/index').default);
Vue.component('tenant-restaurant-cash-filter-pos', require('./views/tenant/Restaurant/cash/filter-pos').default);
Vue.component('tenant-restaurant-configuration', require('./views/tenant/Restaurant/configuration/index').default);

/*
 * Quotations
 */
Vue.component('tenant-quotations-index', require('./views/tenant/Quotations/Index').default);
Vue.component('tenant-quotations-form', require('./views/tenant/Quotations/Form').default);
Vue.component('tenant-quotations-item-form', require('./views/tenant/Quotations/partials/item').default);


/*
 * Discounts
 */
Vue.component('tenant-discounts-index', require('./views/tenant/Discount/index').default);

/*
 * Virtual Shops
 */
Vue.component('tenant-virtual-shops-index', require('./views/tenant/VirtualShop/Index').default);
Vue.component('tenant-labels-index', require('./views/tenant/Label/Index').default);
Vue.component('tenant-shipping-agencies-index', require('./views/tenant/Label/ShippingAgency/Index').default);
Vue.component('tenant-shipping-types-index', require('./views/tenant/Label/ShippingType/Index').default);

//Pagos
Vue.component('tenant-payment-configurations-index', require('./views/tenant/Payment/payment_configurations/index').default);
Vue.component('tenant-public-payment-links-index', require('./views/tenant/Payment/payment_links/public/index').default);
Vue.component('tenant-payment-links-index', require('./views/tenant/Payment/payment_links/index').default);

/*
 * Order
 */
Vue.component('tenant-orders-index', require('./views/tenant/orders/index').default);
Vue.component('tenant-order-forms-index', require('./views/tenant/Order/order_forms/index').default);
Vue.component('tenant-order-forms-form', require('./views/tenant/Order/order_forms/form').default);
Vue.component('tenant-mitiendape-config', require('./views/tenant/Order/mi_tienda_pe/form').default);
Vue.component('tenant-order-notes-index', require('./views/tenant/OrderNotes/Index').default);
Vue.component('tenant-order-notes-form', require('./views/tenant/OrderNotes/Form').default);
// Vue.component('tenant-order-notes-edit', require('./views/tenant/OrderNotes/form_edit').default);

/*
 * Report
 */

Vue.component('tenant-report-purchases-index', require('./views/tenant/Report/purchases/index').default);
Vue.component('tenant-report-documents-index', require('./views/tenant/Report/documents/index').default);
Vue.component('tenant-state-account-index', require('./views/tenant/Report/state_account/index').default);
Vue.component('tenant-report-customers-index', require('./views/tenant/Report/customers/index').default);
Vue.component('tenant-report-items-index', require('./views/tenant/Report/items/index').default);
Vue.component('tenant-report-items-extra-index', require('./views/tenant/Report/items/index_extra').default);
Vue.component('tenant-report-download-tray-index', require('./views/tenant/Report/download_tray/index').default);
Vue.component('tenant-report-guide-index', require('./views/tenant/Report/guide/index').default);
Vue.component('tenant-report-sale_notes-index', require('./views/tenant/Report/sale_notes/index').default);
Vue.component('tenant-report-quotations-index', require('./views/tenant/Report/quotations/index').default);
Vue.component('tenant-report-cash-index', require('./views/tenant/Report/cash/index').default);
Vue.component('tenant-report-document_hotels-index', require('./views/tenant/Report/document_hotels/index').default);
Vue.component('tenant-report_hotels-index', require('./views/tenant/Report/report_hotels/index').default);
Vue.component('tenant-report-commercial_analysis-index', require('./views/tenant/Report/commercial_analysis/index').default);
Vue.component('tenant-report-document-detractions-index', require('./views/tenant/Report/document-detractions/index').default);
Vue.component('tenant-report-commissions-index', require('./views/tenant/Report/commissions/index').default);
Vue.component('tenant-report-order-notes-consolidated-index', require('./views/tenant/Report/order_notes_consolidated/index').default);
Vue.component('tenant-report-general-items-index', require('./views/tenant/Report/general_items/index').default);
Vue.component('tenant-report-order-notes-general-index', require('./views/tenant/Report/order_notes_general/index').default);
Vue.component('tenant-report-sales-consolidated-index', require('./views/tenant/Report/sales_consolidated/index').default);
Vue.component('tenant-report-user-commissions-index', require('./views/tenant/Report/user_commissions/index').default);
Vue.component('tenant-report-fixed-asset-purchases-index', require('./views/tenant/Report/fixed-asset-purchases/index').default);
Vue.component('tenant-report-massive-downloads-index', require('./views/tenant/Report/massive-downloads/index').default);
Vue.component('tenant-report-commissions-detail-index', require('./views/tenant/Report/commissions_detail/index').default);
Vue.component('tenant-report-tips-index', require('./views/tenant/Report/tips/index').default);

/*
 * Offline
 */
Vue.component('tenant-offline-configurations-index', require('./views/tenant/offline_configurations/index').default);

/*
 * Digemid
 */
Vue.component('tenant-digemid-index', require('./views/tenant/Digemid/index').default);

/*
 * Subscription
 */
Vue.component('tenant-suscription-client-index', require('./views/tenant/Subscription/clients/index').default);
Vue.component('tenant-suscription-plans-index', require('./views/tenant/Subscription/plans/index').default);
Vue.component('tenant-suscription-payments-index', require('./views/tenant/Subscription/payments/index').default);
Vue.component('tenant-index-payment-receipt', require('./views/tenant/Subscription/payment_receipt/index').default);
Vue.component('tenant-suscription-grades-index', require('./views/tenant/Subscription/grades/index').default);
Vue.component('tenant-suscription-sections-index', require('./views/tenant/Subscription/sections/index').default);

/*
 * Full Subscription
 */
Vue.component('tenant-full-suscription-client-index', require('./views/tenant/FullSubscription/clients/index').default);
Vue.component('tenant-full-suscription-plans-index', require('./views/tenant/FullSubscription/plans/index').default);
Vue.component('tenant-full-suscription-payments-index', require('./views/tenant/FullSubscription/payments/index').default);
Vue.component('tenant-full-suscription-index-payment-receipt', require('./views/tenant/FullSubscription/payment_receipt/index').default);


/*
 * Hotel
 */
Vue.component('tenant-hotel-rates', require('./views/tenant/Hotel/rates/List').default);
Vue.component('tenant-hotel-categories', require('./views/tenant/Hotel/categories/List').default);
Vue.component('tenant-hotel-floors', require('./views/tenant/Hotel/floors/List').default);
Vue.component('tenant-hotel-rooms', require('./views/tenant/Hotel/rooms/List').default);
Vue.component('tenant-hotel-reception', require('./views/tenant/Hotel/rooms/Reception').default);
Vue.component('tenant-hotel-rent', require('./views/tenant/Hotel/rooms/Rent').default);
Vue.component('tenant-hotel-rent-add-product', require('./views/tenant/Hotel/rooms/AddProductToRoom').default);
Vue.component('tenant-hotel-rent-checkout', require('./views/tenant/Hotel/rooms/Checkout').default);
Vue.component('tenant-hotel-reservation', require('./views/tenant/Hotel/Reservation/Index.vue').default);


/*
 * Sire
 */
Vue.component('tenant-sire-index', require('./views/tenant/sire').default);
Vue.component('tenant-sire-appendix', require('./views/tenant/sire/appendix').default);

/*
 * POS
 */
Vue.component('tenant-pos-index', require('./views/tenant/pos/index').default);
Vue.component('tenant-pos-fast', require('./views/tenant/pos/fast').default);
Vue.component('tenant-pos-garage', require('./views/tenant/pos/Garage').default);
Vue.component('tenant-pos-beta', require('./views/tenant/pos/IndexBeta').default);

/*
 * Dispatches
 */
Vue.component('tenant-dispatches-index', require('./views/tenant/Dispatches/Index').default);
// Vue.component('tenant-dispatches-form', require('./views/tenant/Dispatches/Form').default);
Vue.component('tenant-dispatches-create', require('./views/tenant/Dispatches/Create').default);
Vue.component('tenant-dispatch_carrier-index', require('./views/tenant/Dispatches/Carrier/Index').default);
Vue.component('tenant-dispatch_carrier-form', require('./views/tenant/Dispatches/Carrier/Form').default);
Vue.component('tenant-drivers-index', require('./views/tenant/Dispatches/Drivers/Index').default);
Vue.component('tenant-dispatchers-index', require('./views/tenant/Dispatches/Dispatchers/Index').default);
Vue.component('tenant-transports-index', require('./views/tenant/Dispatches/Transports/Index').default);
Vue.component('tenant-origin_addresses-index', require('./views/tenant/Dispatches/OriginAddress/Index').default);
